import SidebarCustomSection from "discourse/components/sidebar/common/custom-sections";

export default class SidebarAnonymousCustomSections extends SidebarCustomSection {
  anonymous = true;
}
